import React from 'react';
import { useTranslation } from 'react-i18next';

import { EditReimbursementModalButtons } from './EditReimbursementModalButtons';

import {
  PetCloudInput,
  PetCloudInputErrorLabel,
} from '../../../common/petCloud';
import { useCareCreditCardContent } from './hooks/useCareCreditCardContent';
import { CARD_NUMBER_LENGTH } from '../../../../constants';

import styles from '../css/CareCreditCardContentDetail.module.css';

export const STEPS_CARE_CREDIT = {
  assignmentAgreement: 3,
  cardDetails: 0,
  secondarySelection: 1,
  secondarySelectionDetail: 2,
};

const CareCreditCardContentDetail = ({
  goNextStep = () => { },
  goBack = () => { },
}) => {
  const { t } = useTranslation('myAccount');
  const {
    cardNumberError,
    careCredit,
    expDateError,
    firstNameError,
    lastNameError,
    onCancelCareCardDetails,
    onCareCreditNumberBlur,
    onCareCreditNumberChange,
    onExpirationDateBlur,
    onExpirationDateChanged,
    onFirstNameBlur,
    onFirstNameChange,
    onLastNameBlur,
    onLastNameChange,
  } = useCareCreditCardContent({ onCancel: goBack });

  const isFormInvalid = !careCredit.firstName.trim().length
    || !careCredit.lastName.trim().length
    || !careCredit.cardNumber.trim().length
    || !careCredit.expDate
    || firstNameError || lastNameError
    || cardNumberError || expDateError;

  return (
    <form className={styles.contentContainer}>
      <h4 className={styles.contentTitle}>
        {t('reimbursementSection.editModal.careCredit')}
      </h4>

      <div className={styles.inputsContainer}>
        <div>
          <div className={styles.nameContainer}>
            <PetCloudInput
              id="firstName"
              onBlur={onFirstNameBlur}
              onChange={onFirstNameChange}
              title={t('reimbursementSection.careCredit.firstName')}
              value={careCredit.firstName}
            />

            <PetCloudInput
              id="lastName"
              onBlur={onLastNameBlur}
              onChange={onLastNameChange}
              title={t('reimbursementSection.careCredit.lastName')}
              value={careCredit.lastName}
            />
          </div>

          <div className={styles.careNameError}>
            <PetCloudInputErrorLabel error={firstNameError || lastNameError} />
          </div>
        </div>

        <div className={styles.careCreditNumber}>
          <div className={styles.careCreditInputs}>
            <PetCloudInput
              id="careCreditNumber"
              maxLength={CARD_NUMBER_LENGTH}
              onBlur={onCareCreditNumberBlur}
              onChange={onCareCreditNumberChange}
              onPaste={onCareCreditNumberChange}
              title={t('reimbursementSection.careCredit.careCreditNumber')}
              type="text"
              value={careCredit.cardNumber}
            />

            <div className={styles.expirationDateInputContainer}>
              <PetCloudInput
                id="expirationDate"
                maxLength={7}
                onBlur={onExpirationDateBlur}
                onChange={onExpirationDateChanged}
                title={t('reimbursementSection.careCredit.expDate')}
                type="text"
                value={careCredit.expDate}
              />
            </div>
          </div>

          <div>
            <PetCloudInputErrorLabel error={cardNumberError} />

            <PetCloudInputErrorLabel error={expDateError} />
          </div>
        </div>

        <EditReimbursementModalButtons
          handleEditReimbursementAccept={goNextStep}
          handleEditReimbursementCancel={onCancelCareCardDetails}
          isFormInvalid={isFormInvalid}
        />
      </div>
    </form>
  );
};

export { CareCreditCardContentDetail };
